import { cva } from 'class-variance-authority';

/**
 * Progress bar track styles using class-variance-authority.
 */
export const progressBarTrackStyles = cva('w-full rounded-full overflow-hidden bg-neutral-gray-200', {
  variants: {
    size: {
      small: 'h-1',
      medium: 'h-2', 
      large: 'h-3',
    },
    variant: {
      primary: 'bg-brand-primary/[0.26]',
      secondary: 'bg-neutral-gray-200',
      success: 'bg-accent-green-100',
      warning: 'bg-accent-surface-yellow',
      error: 'bg-accent-surface-red',
    },
  },
  defaultVariants: {
    size: 'medium',
    variant: 'primary',
  },
});

/**
 * Progress bar fill styles using class-variance-authority.
 */
export const progressBarFillStyles = cva('h-full rounded-full transition-all duration-300 ease-out', {
  variants: {
    variant: {
      primary: 'bg-brand-primary',
      secondary: 'bg-neutral-gray-500', 
      success: 'bg-accent-status-green',
      warning: 'bg-accent-status-yellow',
      error: 'bg-accent-status-red',
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
});